import type { SpeechToTextCredentials } from './providers/speech-to-text-provider';

export type { SpeechToTextCredentials } from './providers/speech-to-text-provider';

type Fetcher = (productId?: string) => Promise<SpeechToTextCredentials>;

export function createCredentialsCache() {
  const cached = new Map<string, SpeechToTextCredentials>();
  const inflight = new Map<string, Promise<SpeechToTextCredentials>>();

  function keyOf(productId?: string): string {
    return productId ?? '__default__';
  }

  function isFresh(c: SpeechToTextCredentials | undefined): c is SpeechToTextCredentials {
    if (!c) return false;
    const ts = new Date(c.expiresAt).getTime();
    if (Number.isNaN(ts)) return false;
    return ts - Date.now() > 60_000;
  }

  return {
    async get(productId: string | undefined, fetcher: Fetcher): Promise<SpeechToTextCredentials> {
      const key = keyOf(productId);
      const c = cached.get(key);
      if (isFresh(c)) return c;
      let p = inflight.get(key);
      if (!p) {
        p = fetcher(productId)
          .then(creds => {
            cached.set(key, creds);
            return creds;
          })
          .finally(() => {
            inflight.delete(key);
          });
        inflight.set(key, p);
      }
      return p;
    },
    clear() {
      cached.clear();
      inflight.clear();
    },
  };
}
